///*eslint-disable jsx-a11y/aria-role */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  Row,
  Container,
  Navbar,
  Nav,
  NavDropdown,
  OverlayTrigger,
  Popover,
  Col,
  Accordion,
  Card,
} from 'react-bootstrap';
//import './header.scss';
import { useSelector, useDispatch } from 'react-redux';
import { HeaderSVG } from '../../img/GlobalSVG';
import MasterPermissions from '../../api/MasterPermissions';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import OutsideClickHandler from 'react-outside-click-handler';

//import { Link } from 'react-router-dom';
import { logout, setUserData } from '../../../redux/app/userSlice';
import { useTranslation } from 'react-i18next';
import { resetRecentSearchList } from '../../../redux/member/priceCompareSlice';
import { AccordionDownArrow } from 'src/Member/img/findcare/FindCareSVG';
import OtherUserImg from '../../img/OtherUserImg.png';
import SelectedUserImg from '../../img/SelectedUserImg.png';
import {
  ToolTipNotificationBellSVG,
  NotificationBellSVG,
  NotificationBellSVGWithBadge,
  AffiliateAccountSVG,
} from '../../img/NotificationSVG';
import HelpCenterImage from '../../img/Help-Center.svg';
import NotificationPopup from '../Message&Documents/NotificationPopup';
import NotificationPopupSkeleton from 'src/Components/skeletons/NotificationPopupSkeleton';
import Avatar from '../common/avatar-with-initials';
import { HelpCenterNew as HelpIcon } from 'src/Admin/img/HelpCenterNew';
import APIEndpoints from '../../../../src/Member/api/APIEndpoints'; //getNotificationcountapi
import { axiosInstance } from '../../../../src/api/axios';
//import './header.scss';
import { getPortalName } from 'src/utils';
import {
  setIsDataFeching,
  setNotificationResp,
} from 'src/redux/app/messageAndNotificationSlice';
const PortalName = ({
  isPublic,
  isSecure,
  getNotificationCount,
  setGetNotificationCount,
  fromSideNav = false,
}) => {
  const { t } = useTranslation();
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );
  const { NotificationResp, isDataFeching } = useSelector(
    (state) => state?.messageAndNotification,
  );
  const { isLoggedIn, userData, adminConfigData } = useSelector(
    (state) => state.user,
  );
  const [isMenuDisabled, setMenuDisabled] = useState(false);
  //const [notificationCount, setNotificationCount] = useState('9');
  const [activeId, setActiveId] = useState(0);
  const [showNotificationBody, setShowNotificationBody] = useState(
    fromSideNav ? null : '0',
  );
  const [showNotification, setShowNotification] = useState(
    fromSideNav ? false : true,
  );
  //const [getNotificationCount, setGetNotificationCount] = useState([]);
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const [viewDocuments, setViewDocuments] = useState(false);
  const [messageDetails, setMessageDetails] = useState([]);
  const notificationCount = '9';
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutAction = () => {
    //dispatch(logout({ preserveBearerToken: true }));
    //dispatch(resetRecentSearchList());
    navigate('/member/logout');
    console.log('M Portal Logout -> isAuthenticated: ');
  };

  const mainHeading = getPortalName().mainHeadeing;
  const subHeading = isLoggedIn
    ? getPortalName(userData.UserType).subHeading || 'Member Portal'
    : 'Member Portal';

  const allowDualCoverage =
    adminConfigData?.Response?.InsurerClientSettings
      ?.AllowDualCoverageAfterRegistration;
  console.log('allowDualCoverage', allowDualCoverage);

  useEffect(() => {
    if (
      location.pathname.includes('/member/page/') &&
      location.search.includes('&newTab')
    ) {
      setMenuDisabled(true);
    } else {
      setMenuDisabled(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    //Check Send Document
    const sendDocumentFlag =
      FEATURES && FEATURES?.find((feature) => feature.Name === 'SendDocument');
    sendDocumentFlag && sendDocumentFlag.Status === true
      ? setViewDocuments(true)
      : setViewDocuments(false);
  }, [FEATURES]);

  useEffect(() => {
    setShowNotificationBody(fromSideNav ? null : '0');
    if (location.pathname.includes('/member/dashboard')) {
      if (fromSideNav) {
        setTimeout(() => {
          setShowNotification(true);
          setShowNotificationBody(null);
        }, 1000);
      } else {
        setShowNotification(false);
      }
    } else {
      setShowNotification(false);
      if (fromSideNav) {
        setTimeout(() => {
          setShowNotificationBody(null);
        }, 100);
      }
    }
  }, [location.pathname]);

  const TotalMessageAndNotificationCount =
    Number(NotificationResp?.MessageCount?.Message) +
    Number(NotificationResp?.MessageCount?.Notification);

  useEffect(() => {
    if (isSecure === true) {
      notificationCountList(false);
    }
  }, [isSecure]);

  //getNotificationcountapi
  const notificationCountList = async (showSkeletonLoader = true) => {
    showSkeletonLoader && dispatch(setIsDataFeching(true));
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      const MessageDetails =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageDetail;
      dispatch(
        setNotificationResp(
          responseNotification?.data?.Response?.ResponseObectForNotification,
        ),
      );
      setGetNotificationCount(MessageCounts);
      setMessageDetails(MessageDetails);
      return 'success';
    } catch (error) {
      return 0;
    } finally {
      dispatch(setIsDataFeching(false));
    }
  };

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const notificationPopupTitleRef = useRef(null);
  const notificationBellIconRef = useRef(null);

  const notificationShowHideHandler = async () => {
    if (showNotification == false) {
      const resp = await notificationCountList();
      if (resp) {
        setShowNotification(true);
        setShowNotificationBody(null);
      }
    } else {
      setShowNotification(!showNotification);
      setShowNotificationBody(fromSideNav ? null : '0');
    }
  };

  const closeNotificationHandler = () => {
    setShowNotification(false);
  };

  useEffect(() => {
    if (showNotification === true)
      setTimeout(() => {
        if (notificationPopupTitleRef?.current) {
          notificationPopupTitleRef?.current?.focus();
        }
      }, 500);
  }, [showNotification]);

  const handleAccountChange = async (member) => {
    console.log('debug_Selected Member:', member);
    dispatch(setUserData({ MemberDetails: member }));
    navigate('/member/dashboard');
  };

  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={(e) => {
          const isNotificationClicked =
            e?.toElement?.classList?.value?.includes('responsive-notification');
          if (isNotificationClicked) {
            navigate('/member/messages-documents-notifications', {
              state: {
                state: 'mymessage',
                showmymessage: true,
                notificationCount: NotificationResp?.MessageCount,
              },
            });
          }
          if (showNotification == true) {
            setShowNotification(false);
          }
        }}
      >
        <div className="portal-name-container d-flex justify-content-md-end">
          <Helmet>
            <meta charSet="utf-8" />
            <title>{`${mainHeading} - ${subHeading}`}</title>
          </Helmet>
          <div
            className={`d-flex flex-column header-sub-section portal-name-subsection ${
              isSecure ? 'border-right' : ''
            }`}
          >
            {/*#TODO: make dynamic */}
            <p className="m-0 p-0 text-right main-heading">
              {/*{getPortalName().mainHeadeing}*/}
              {mainHeading}
            </p>
            {/*#TODO: make dynamic */}
            {
              <p className="m-0 p-0 text-right sub-heading">
                {/*{isLoggedIn
              ? getPortalName(userData.UserType).subHeading || 'Member Portal'
              : 'Member Portal'}*/}
                {subHeading}
              </p>
            }
          </div>
          {isSecure && (
            <>
              <div className="header-sub-section d-flex align-items-center">
                <Link
                  to="/member/help-center"
                  className="help-icon-main"
                  aria-label="Click to open Help Center Page."
                >
                  {/*<img src={HelpCenterImage} alt="logo" />*/}
                  <div className="help-icon-container">
                    <HelpIcon className={'help-icon'} />
                  </div>
                </Link>
              </div>
              {viewDocuments && (
                <div className="header-sub-section d-flex align-items-center">
                  <div className="notification">
                    <OverlayTrigger
                      show={showNotification || isDataFeching}
                      placement={fromSideNav ? 'bottom' : 'bottom-end'}
                      delay={{ show: 500, hide: 450 }}
                      overlay={
                        <Popover
                          className={`popover_notification ${fromSideNav}-sidebar-overlay `}
                        >
                          <Popover.Content
                            className={`${
                              fromSideNav ? 'responsive-notification' : ''
                            }`}
                          >
                            <Accordion eventKey="0" role="tablist">
                              {isDataFeching ? (
                                <Card
                                  className={`${
                                    fromSideNav ? 'responsive-notification' : ''
                                  }`}
                                >
                                  <NotificationPopupSkeleton />
                                </Card>
                              ) : (
                                <Card
                                  className={`${
                                    fromSideNav ? 'responsive-notification' : ''
                                  }`}
                                >
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    onClick={() => {
                                      setShowNotification(true),
                                        toggleActive(0);
                                    }}
                                    className="panel-toggle text-left w-100"
                                    eventKey="0"
                                    role="tab"
                                    aria-expanded={activeId == '0'}
                                  >
                                    <div className="d-flex panel-card-header">
                                      <div
                                        className={`accordian-notification ${
                                          fromSideNav
                                            ? 'responsive-notification'
                                            : ''
                                        }`}
                                      >
                                        <span
                                          className="sr-only"
                                          role="status"
                                        >{`Notification Tab ${
                                          activeId == '0'
                                            ? 'Expanded'
                                            : 'Collapsed'
                                        }`}</span>
                                        <Row className="notification-tooltip justify-content-between align-items-center">
                                          <Col
                                            className={` ${
                                              fromSideNav
                                                ? 'responsive-notification'
                                                : ''
                                            } notification-icon`}
                                          >
                                            <ToolTipNotificationBellSVG />
                                          </Col>
                                          <Col
                                            className={` ${
                                              fromSideNav
                                                ? 'responsive-notification'
                                                : ''
                                            } notification-content pl-3`}
                                          >
                                            {TotalMessageAndNotificationCount >
                                            0 ? (
                                              <>
                                                <span
                                                  className={` ${
                                                    fromSideNav
                                                      ? 'responsive-notification'
                                                      : ''
                                                  } tooltip-header`}
                                                  ref={
                                                    notificationPopupTitleRef
                                                  }
                                                  role="heading"
                                                  aria-level={4}
                                                  tabIndex={-1}
                                                  aria-label={`You have ${TotalMessageAndNotificationCount} Notifications`}
                                                >
                                                  {`You have ${TotalMessageAndNotificationCount} Notifications`}
                                                </span>
                                                <br />
                                                <div
                                                  className={` ${
                                                    fromSideNav
                                                      ? 'responsive-notification'
                                                      : ''
                                                  } tooltip-content-text`}
                                                >
                                                  {`${
                                                    NotificationResp
                                                      ?.MessageCount?.Message
                                                  } Messages and ${
                                                    NotificationResp
                                                      ?.MessageCount
                                                      ?.Notification || ''
                                                  } Updates / Reminders`}
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                <div className="No-notifications-found">
                                                  You don’t have any
                                                  notification right now.
                                                </div>
                                              </>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </Accordion.Toggle>

                                  <Accordion.Collapse
                                    eventKey={
                                      fromSideNav ? '' : showNotificationBody
                                    }
                                  >
                                    <Card.Body>
                                      <NotificationPopup
                                        getNotificationCount={
                                          NotificationResp?.MessageCount
                                        }
                                        messageDetails={messageDetails}
                                        setShowNotification={
                                          setShowNotification
                                        }
                                        isNotificationPopupList={true}
                                      />
                                      <button
                                        className="sr-only"
                                        onClick={() => {
                                          setShowNotification(false);
                                          if (
                                            notificationBellIconRef?.current
                                          ) {
                                            notificationBellIconRef?.current?.focus();
                                          }
                                        }}
                                      >
                                        Skip to main content
                                      </button>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              )}
                            </Accordion>
                          </Popover.Content>
                        </Popover>
                      }
                    >
                      <div
                        className="header-notification-div"
                        onClick={() => notificationShowHideHandler()}
                        tabIndex={0}
                        role="button"
                        aria-label={`${
                          TotalMessageAndNotificationCount > 0
                            ? `You have ${TotalMessageAndNotificationCount} unread notifications, `
                            : ''
                        } click to open message or notification popup`}
                        ref={notificationBellIconRef}
                      >
                        {TotalMessageAndNotificationCount > 0 ? (
                          <NotificationBellSVGWithBadge
                            className="header-notification-svg"
                            parentClassName="background-notification-svg"
                            badgeClassName="header-notification-badge-svg"
                          />
                        ) : (
                          <NotificationBellSVG
                            className="header-notification-svg"
                            parentClassName="background-notification-svg"
                          />
                        )}
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              )}
              {!isMenuDisabled && (
                <div className="header-sub-section d-none d-md-flex  align-items-center">
                  <Navbar collapseOnSelect expand="lg">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto"></Nav>
                      {isLoggedIn && (
                        <Nav
                          id="header-main-menu"
                          aria-label="Header Main Menu"
                        >
                          <NavDropdown
                            onClick={() => closeNotificationHandler()}
                            title={
                              <div className="d-flex user-avatar-container">
                                <Avatar
                                  fname={userData?.FirstName}
                                  lname={userData?.LastName}
                                  className={'size-32'}
                                />
                                <AccordionDownArrow className="acc-arrow" />
                              </div>
                            }
                            id="collasible-nav-dropdown"
                          >
                            {userData?.MemberDetailsList &&
                              userData?.MemberDetailsList.map((member) => (
                                <NavDropdown.Item
                                  className="p-0"
                                  href="#"
                                  key={member.MemberOID}
                                >
                                  <div
                                    key={member.MemberOID}
                                    className={`d-flex user-inform ${
                                      member.MemberOID ===
                                      userData?.MemberDetails?.MemberOID
                                        ? 'selected-userinfo'
                                        : 'other-userinfo'
                                    }`}
                                    onClick={() => handleAccountChange(member)}
                                  >
                                    <div>
                                      {member.MemberOID ===
                                      userData?.MemberDetails?.MemberOID ? (
                                        <img
                                          src={SelectedUserImg}
                                          alt="SelectedUser"
                                        />
                                      ) : (
                                        <img
                                          src={OtherUserImg}
                                          alt="Otheruser"
                                        />
                                      )}
                                    </div>
                                    <div
                                      key={member.MemberOID}
                                      className="pl-1"
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        trigger="hover"
                                        key={member}
                                        overlay={
                                          (
                                            member.MemberName +
                                            ' ' +
                                            (member?.MemberType ===
                                              'employee' ||
                                            member?.MemberType === 'Employee'
                                              ? '(Member)'
                                              : '(Dependent)')
                                          ).length > 22 ? (
                                            <Popover>
                                              <Popover.Content>
                                                <div
                                                  style={{ fontWeight: 600 }}
                                                >
                                                  {member.MemberName}{' '}
                                                  {member?.MemberType ===
                                                    'employee' ||
                                                  member?.MemberType ===
                                                    'Employee'
                                                    ? '(Member)'
                                                    : '(Dependent)'}
                                                </div>
                                              </Popover.Content>
                                            </Popover>
                                          ) : (
                                            <span></span>
                                          )
                                        }
                                      >
                                        <p
                                          className={
                                            member.MemberOID ===
                                            userData?.MemberDetails?.MemberOID
                                              ? 'selected-userinfo-username m-0'
                                              : 'other-userinfo-username m-0'
                                          }
                                        >
                                          {member.MemberName}{' '}
                                          {member?.MemberType === 'employee' ||
                                          member?.MemberType === 'Employee'
                                            ? '(Member)'
                                            : '(Dependent)'}
                                        </p>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        trigger="hover"
                                        key={member}
                                        overlay={
                                          member?.ClientName.length > 32 ? (
                                            <Popover>
                                              <Popover.Content>
                                                <div
                                                  style={{ fontWeight: 600 }}
                                                >
                                                  {member?.ClientName}
                                                </div>
                                              </Popover.Content>
                                            </Popover>
                                          ) : (
                                            <span></span>
                                          )
                                        }
                                      >
                                        <p
                                          className={
                                            member.MemberOID ===
                                            userData?.MemberDetails?.MemberOID
                                              ? 'selected-userinfo-clientname'
                                              : 'other-userinfo-clientname'
                                          }
                                        >
                                          {member?.ClientName.toLowerCase()}
                                        </p>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                </NavDropdown.Item>
                              ))}
                            {allowDualCoverage && (
                              <NavDropdown.Item
                                as={Link}
                                to="/member/affiliate-account"
                                className="p-0"
                              >
                                <div className="p-2 other-userinfo">
                                  <AffiliateAccountSVG
                                    className={'affiliate-account-plus-svg'}
                                  />
                                  <span className="affiliate-account-title">
                                    Affiliate Account
                                  </span>
                                </div>
                              </NavDropdown.Item>
                            )}
                            {MasterPermissions.CheckPermission('Profile') && (
                              <NavDropdown.Item
                                as={Link}
                                to="/member/my-profile"
                              >
                                {/*<Link
                              to="/member/my-profile"
                              role="button"
                              className="dropdown-item"
                              aria-label="View My Profile"
                            >*/}
                                {t('header.my_profile')}
                                {/*</Link>*/}
                              </NavDropdown.Item>
                            )}
                            <NavDropdown.Item
                              href="#"
                              role="button"
                              onClick={logoutAction}
                            >
                              {t('header.logout')}
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                          </NavDropdown>
                        </Nav>
                      )}
                    </Navbar.Collapse>
                  </Navbar>
                </div>
              )}
            </>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default PortalName;
